import React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import {
  VictoryChart,
  VictoryLine,
  VictoryScatter,
  VictoryAxis,
} from 'victory';

import { ChartContainer, ChartOverlay } from './styles';
import { colors } from '../../../config/theme';

const LabelBox = styled.div`
  width: 10px;
  height: 10px;
  background: ${(props) => props.color};
  margin-right: 10px;
  border: 1px solid white;
`;

const BoxLabelFont = styled.div`
  font-size: 12px;
`;

export const TrendsChart = ({
  dataSet,
  secondDataSet,
  thirdDataSet,
  title,
  labelConfig,
}) => {
  const upperAxisBound = Math.max(...dataSet.map((item) => item.y), 10);
  const { label1, label2, label3 } = labelConfig;
  return (
    <Card>
      <CardContent>
        <Box>
          <Typography variant="h6">{title}</Typography>
        </Box>
      </CardContent>
      <ChartContainer>
        <ChartOverlay />
        <Flex pl="20px">
          <Flex mr="10px">
            <LabelBox color={colors.chart.one} />
            <BoxLabelFont>{label1}</BoxLabelFont>
          </Flex>
          {label2 && (
            <Flex mr="10px">
              <LabelBox color={colors.chart.two} />
              <BoxLabelFont>{label2}</BoxLabelFont>
            </Flex>
          )}
          {label3 && (
            <Flex>
              <LabelBox color={colors.chart.three} />
              <BoxLabelFont>{label3}</BoxLabelFont>
            </Flex>
          )}
        </Flex>
        <VictoryChart domainPadding={10}>
          <VictoryLine
            animate={{
              duration: 1500,
              onLoad: { duration: 500 },
            }}
            data={dataSet}
            style={{
              data: {
                stroke: colors.chart.one,
                strokeWidth: 2,
                strokeLinecap: 'round',
              },
            }}
          />
          <VictoryScatter
            data={dataSet}
            style={{
              data: { fill: colors.chart.one },
            }}
          />

          {secondDataSet && (
            <VictoryLine
              data={secondDataSet}
              style={{
                data: {
                  strokeDasharray: '4, 4',
                  stroke: colors.chart.two,
                  strokeWidth: 2,
                  strokeLinecap: 'round',
                },
              }}
            />
          )}

          {secondDataSet && (
            <VictoryScatter
              data={secondDataSet}
              style={{
                data: { fill: colors.chart.two },
              }}
            />
          )}
          {thirdDataSet && (
            <VictoryLine
              animate={{
                duration: 1500,
                onLoad: { duration: 500 },
              }}
              data={thirdDataSet}
              style={{
                data: {
                  strokeDasharray: '4, 4',
                  stroke: colors.chart.three,
                  strokeWidth: 2,
                  strokeLinecap: 'round',
                },
              }}
            />
          )}
          {thirdDataSet && (
            <VictoryScatter
              data={thirdDataSet}
              style={{
                data: { fill: colors.chart.three },
              }}
            />
          )}
          <VictoryAxis
            style={{
              axis: {
                stroke: colors.textPrimary,
              },
              tickLabels: {
                fill: colors.textPrimary,
              },
            }}
          />
          <VictoryAxis
            dependentAxis
            style={{
              axis: {
                stroke: colors.textPrimary,
              },
              tickLabels: {
                fill: colors.textPrimary,
              },
              grid: {
                stroke: 'gray',
                strokeDasharray: '2, 2',
              },
            }}
          />
          <VictoryAxis
            dependentAxis
            domain={[0, upperAxisBound]}
            style={{
              axis: {
                stroke: colors.textPrimary,
              },
              tickLabels: {
                fill: colors.textPrimary,
              },
            }}
          />
        </VictoryChart>
      </ChartContainer>
    </Card>
  );
};
